import React, { useEffect, useState, useContext, useRef } from "react";
import { useParams } from "react-router";
import { Shimmer, Image } from "react-shimmer";
import { OutlinedInput, Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import styles from "./index.module.css";
import { appendImageUrl, isMobiledevice } from "../../utils/helperFunctions";
import { api_call, api_call_token } from "../../utils/Network";
import { MainContext } from "../../utils/context";
import Dropdown from "../../components/Dropdown";
import Carousels from "../../components/Carousel/Carousel";
import ReviewRating from "../../components/ReviewRating/ReviewRating";
import { useHistory } from "react-router-dom";

const emptyServiceList = [
  {
    service_id: 1,
    service_name: "",
    service_image: "",
    service_icon: "",
    sub_service: [],
  },
  {
    service_id: 2,
    service_name: "",
    service_image: "",
    service_icon: "",
    sub_service: [],
  },
  {
    service_id: 3,
    service_name: "",
    service_image: "",
    service_icon: "",
    sub_service: [],
  },
  {
    service_id: 4,
    service_name: "",
    service_image: "",
    service_icon: "",
    sub_service: [],
  },
  {
    service_id: 5,
    service_name: "",
    service_image: "",
    service_icon: "",
    sub_service: [],
  },
  {
    service_id: 6,
    service_name: "",
    service_image: "",
    service_icon: "",
    sub_service: [],
  },
];

function Cart() {
  const { cat_id: pcat_id, var_id: pvar_id, ser_id: pser_id } = useParams();
  const { cartData, setCartData, userData, setCurrentPath } = useContext(
    MainContext
  );
  const [loading, setLoading] = useState(true);
  const [alreadyInCart, setAlreadyInCart] = useState({});
  const [mainVariant, setMainVariant] = useState([]);
  const [variantList, setVariantList] = useState([]);
  const [variantSelected, setVariantSelected] = useState({});
  const [subVariantList, setSubVariantList] = useState([]);
  const [subVariantSelected, setSubVariantSelected] = useState({});
  const [servicesList, setServicesList] = useState(emptyServiceList);
  const [serviceSelected, setServiceSelected] = useState({ service_id: 1 });
  const [subServiceList, setSubServiceList] = useState([]);
  const [subServiceSelected, setSubServiceSelected] = useState({});
  const [exclusivesSelectedList, setExclusivesSelectedList] = useState([]);
  const [updatedExclusiveList, setUpdatedExclusiveList] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [heros, setHeros] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [msg, setMsg] = useState("");
  const [activeRef, setActiveRef] = useState("Overview");
  const [sqftTotalPrice, setSqftTotalPrice] = useState(0);
  const heroesRef = useRef(null);
  const reviewsRef = useRef(null);
  let history = useHistory();

  useEffect(() => {
    let href = window.location.href.split("/");
    setCurrentPath(href[4]);
    getHeros();
  }, []);
  useEffect(() => getServiceData(), [pvar_id, pser_id]);
  useEffect(() => { }, [userData, cartData]);
  useEffect(() => {
    setMainVariant([{ variant_name: 'Residential', variant_id: 1 }, { variant_name: 'Commercial', variant_id: 2 }])
  },[])

  const getServiceData = () => {
    window.scrollTo(0, 0);
    api_call
      .post(`service_list/services/`, {
        category_id: pcat_id,
        sub_category: pvar_id === "1" ? "residential" : "commercial",
      })
      .then((response) => {
        const data = response.data.data;
        if (data.length && data[0].variant.length) {
          setVariantList(data[0].variant);
          const [variant] = data[0].variant;
          setVariantSelected(variant);
          if (variant.sub_variant.length) {
            setSubVariantList(variant.sub_variant);
            const [sub_variant] = variant.sub_variant;
            setSubVariantSelected(sub_variant);
            if (sub_variant.services.length) {
              setServicesList(sub_variant.services);
              let service = {};
              if (parseInt(pser_id)) {
                sub_variant.services.forEach((s) => {
                  if (s.service_id == pser_id) service = s;
                });
              } else service = sub_variant.services[0];
              getReviews(service.service_id);
              alreadyInCarthandler(service);
              setServiceSelected(service);
              setSubServiceList(service.sub_service);
            } else {
              setServiceSelected({});
              setServicesList([]);
              setSubServiceList([]);
            }
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error.response, "Error occured");
        setLoading(false);
      });
  };

  const mainvariantDropdownHandler = (e) => {
    const vars = mainVariant[e.target.value].variant_id;
    console.log(vars,pcat_id,pser_id)
  history.push(`/cart/${pcat_id}/${vars}/${pser_id}`)

  }

  const variantDropdownHandler = (e) => {
    const variant = variantList[e.target.value];
    setVariantSelected(variant);
    // const variant = { sub_variant: [] };
    // console.log(e.target.value,variantList);
    if (variant.sub_variant?.length) {
      setSubVariantList(variant.sub_variant);
      const [sub_variant] = variant.sub_variant;
      setSubVariantSelected(sub_variant);
      if (sub_variant.services.length) {
        setServicesList(sub_variant.services);
        const [service] = sub_variant.services;
        if (service.service_id) {
          alreadyInCarthandler(service);
          getReviews(service.service_id);
          setServiceSelected(service);
          setSubServiceList(service.sub_service);
        }
      }
    }
  };

  const subVariantDropdownHandler = (e) => {
    const sub_variant = subVariantList[e.target.value];
    setSubVariantSelected(sub_variant);
    if (sub_variant.services.length) {
      setServicesList(sub_variant.services);
      const [service] = sub_variant.services.filter(
        (service) => service.service_id === serviceSelected.service_id
      );
      if (service.service_id) {
        // if (service.service_price?.is_per_sq_feet)
        //   setTotalPrice(service.service_price?.price * 2000);
        alreadyInCarthandler(service);
        getReviews(service.service_id);
        setServiceSelected(service);
        setSubServiceList(service.sub_service);
      }
    }
  };

  const serviceSelectHandler = (service = {}, subServices = []) => {
    setServiceSelected(service);
    setSubServiceList(subServices);
    alreadyInCarthandler(service);
    getReviews(service.service_id);
  };

  const alreadyInCarthandler = (service = {}) => {
    if (service.service_id && cartData && cartData.length) {
      const inCart = cartData.find(
        (c) => c.price_id === service.service_price?.price_id
      );
      if (inCart && inCart.service_id) {
        let total = 0;
        setAlreadyInCart(inCart);
        if (inCart.sub_service?.length) {
          setExclusivesSelectedList(inCart.sub_service);
          inCart.sub_service.forEach(
            (ss) => (total = total + ss.service_total)
          );
        }
        setTotalPrice(total);
      } else {
        setExclusivesSelectedList([]);
        setTotalPrice(0);
        setAlreadyInCart({});
        setUpdatedExclusiveList([]);
      }
    }
  };

  const exclusiveSubServiceQtyHandler = (sub_service = {}, increase = true) => {
    if (sub_service.service_price?.price) {
      const newExclusive = {
        ...sub_service,
        service_price: sub_service.service_price?.price,
        service_total: sub_service.service_price?.price,
        price_id: sub_service.service_price?.price_id,
        quantity: 1,
      };
      setExclusivesSelectedList([...exclusivesSelectedList, newExclusive]);
      setTotalPrice(totalPrice + sub_service.service_price?.price);
      if (alreadyInCart.price_id)
        setUpdatedExclusiveList([...updatedExclusiveList, newExclusive]);
    } else if (sub_service.service_price) {
      if (sub_service.quantity > 1 || increase) {
        setExclusivesSelectedList(
          exclusivesSelectedList.map((e) => {
            if (e.service_id === sub_service.service_id) {
              const updatedExclusive = {
                ...e,
                quantity: increase ? e.quantity + 1 : e.quantity - 1,
                service_total: increase
                  ? sub_service.service_total + sub_service.service_price
                  : sub_service.service_total - sub_service.service_price,
              };
              setUpdatedExclusiveList([
                ...updatedExclusiveList.filter(
                  (u) => u.service_id !== e.service_id
                ),
                updatedExclusive,
              ]);
              return updatedExclusive;
            }
            return e;
          })
        );
        setTotalPrice(
          increase
            ? totalPrice + sub_service.service_price
            : totalPrice - sub_service.service_price
        );
      } else {
        setExclusivesSelectedList(
          exclusivesSelectedList.filter((e) => {
            if (e.service_id === sub_service.service_id)
              setUpdatedExclusiveList([
                ...updatedExclusiveList.filter(
                  (u) => u.service_id !== e.service_id
                ),
                { ...e, quantity: 0 },
              ]);
            return e.service_id !== sub_service.service_id;
          })
        );
        setTotalPrice(totalPrice - sub_service.service_price);
      }
    } else setMsg("Something went wrong, please try again later.");
  };

  const addToCartHandler = () => {
    if (serviceSelected.service_price?.is_per_sq_feet && sqftTotalPrice < 1000)
      return setMsg("Please enter sq. ft.");
    setUpdatedExclusiveList([]);
    const sqFeet = sqftTotalPrice
      ? parseInt(sqftTotalPrice / serviceSelected.service_price?.price)
      : 1;
    let commonData = {
      variant_type: variantSelected.variant_name,
      sub_variant_type: subVariantSelected.sub_variant_name,
    };
    if (userData?.id) commonData = { user_id: userData.id, ...commonData };
    let data = {
      service_name: serviceSelected.service_name,
      service_id: serviceSelected.service_id,
      price_id: serviceSelected.service_price?.price_id,
      service_price: serviceSelected.service_price?.price,
      service_image: serviceSelected.service_icon,
      sq_feet: sqFeet,
      quantity: sqFeet,
      ...commonData,
    };
    if (exclusivesSelectedList.length) {
      let exclusiveData = exclusivesSelectedList.map(
        (exclusive) =>
        (exclusive = {
          ...exclusive,
          parent_service_id: exclusive.parent_id,
          parent_price_id: data.price_id,
          ...commonData,
        })
      );
      setAlreadyInCart({ ...data, sub_service: exclusiveData });
      setExclusivesSelectedList(exclusiveData);
      cartData
        ? setCartData([...cartData, { ...data, sub_service: exclusiveData }])
        : setCartData([{ ...data, sub_service: exclusiveData }]);
      data = [data, ...exclusiveData];
    } else {
      setAlreadyInCart(data);
      data = [data];
      cartData ? setCartData([...cartData, ...data]) : setCartData(data);
    }
    if (userData?.id) {
      api_call_token
        .post("auth/cart/create_cart/", data)
        .then((re) => setMsg("Added to cart successfully"))
        .catch((e) => console.log(e));
    } else setMsg("Added to cart successfully");
    // history.goBack();
    // setTimeout(() => history.push("proceed"), 6);
  };

  const updateCartHandler = () => {
    setAlreadyInCart({ ...alreadyInCart, sub_service: exclusivesSelectedList });
    setCartData([
      ...cartData.filter((c) => c.price_id !== alreadyInCart.price_id),
      { ...alreadyInCart, sub_service: exclusivesSelectedList },
    ]);
    let newExclusiveList = [];
    if (userData.id) {
      updatedExclusiveList.map((u) => {
        if (u.active_status && u.quantity > 0) {
          newExclusiveList.push({
            ...u,
            user_id: userData.id,
            parent_price_id: alreadyInCart.price_id,
            variant_type: variantSelected.variant_name,
            sub_variant_type: subVariantSelected.sub_variant_name,
          });
        } else {
          api_call_token
            .patch("auth/cart/update_cart/", {
              price_id: u.price_id,
              quantity: u.quantity,
            })
            .then((r) => setCartData(r.data.data))
            .catch((e) => console.log(e));
        }
      });
    }
    if (newExclusiveList.length) {
      api_call_token
        .post("auth/cart/create_cart/", newExclusiveList)
        .then((re) => setMsg("Updated cart successfully"))
        .catch((e) => console.log(e));
    }
    setUpdatedExclusiveList([]);
  };

  const getHeros = () => {
    api_call
      .get("service_list/info/squad/")
      .then((response) => setHeros(response.data.data))
      .catch((error) => console.log(error));
  };

  const getReviews = (serviceId = 0) => {
    api_call
      .post(`auth/ratings/view_review/`, { service_id: serviceId })
      .then((response) => setReviews(response.data.data))
      .catch((error) => {
        console.log(error.response, "Error occured");
      });
  };

  return (
    <>
      {msg && (
        <Snackbar
          open
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          onClose={() => setMsg("")}
          autoHideDuration={3000}
          message={msg}
        >
          <Alert severity={msg.includes("lease") ? "error" : "success"}>
            {msg}
          </Alert>
        </Snackbar>
      )}
      <div className={styles.categoryBar}>
        {servicesList.length > 0 &&
          servicesList.map((service, i) => (
            <div
              key={i}
              className={styles.category}
              onClick={() => serviceSelectHandler(service, service.sub_service)}
            >
              <Image
                src={appendImageUrl(
                  service.service_icon
                    ? service.service_icon
                    : !loading && "/files/files/Group_49_xVPEXu3.png"
                )}
                NativeImgProps={{
                  style: {
                    objectFit: "contain",
                    height: 36,
                    width: 36,
                    marginBottom: 4,
                  },
                }}
                fallback={<Shimmer width={36} height={36} />}
                errorFallback={() => <Shimmer width={36} height={36} />}
              />
              <h4 style={{ margin: 3 }}>
                {service.service_name || <Shimmer height={10} width={86} />}
              </h4>
              <div
                style={{
                  backgroundColor:
                    serviceSelected.service_id === service.service_id
                      ? "#dbac40"
                      : "#fff",
                }}
                className={styles.activ}
              ></div>
            </div>
          ))}
      </div>
      <div
        style={{
          backgroundImage: `url(${appendImageUrl(
            serviceSelected.service_image
              ? serviceSelected.service_image
              : "/files/files/Group_472x_Wj1mM5u.png"
          )})`,
        }}
        className={styles.banner}
      >
        <h2 className={styles.bannerText}>{serviceSelected.service_name}</h2>
        <p className={styles.duration}>
          Duration : {serviceSelected.service_price?.duration} | Crew :{" "}
          {serviceSelected.service_price?.crew}
        </p>
      </div>
      <div className={styles.cartMainContainer}>
        <div style={{ width: "100%" }}>
          <div className={styles.serviceBar}>
            {["Overview", "Heroes", "Reviews"].map((i) => (
              <div
                key={i}
                onClick={() => {
                  if (i === "Heroes")
                    heroesRef.current.scrollIntoView({ behavior: "smooth" });
                  else if (i === "Reviews")
                    reviewsRef.current.scrollIntoView({ behavior: "smooth" });
                  else window.scrollTo(0, 0);
                  setActiveRef(i);
                }}
                className={styles.serviceName}
              >
                <h4>{i}</h4>
                <div
                  style={{
                    marginTop: 20,
                    marginBottom: -27,
                    backgroundColor: activeRef === i ? "#dbac40" : "#fff",
                  }}
                  className={styles.activ}
                ></div>
              </div>
            ))}
          </div>
          <div className={styles.serviceContainer}>
            <h3 className={styles.sectionTitle}>Overview</h3>
            {serviceSelected.service_description && (
              <p className={styles.desc}>
                {serviceSelected.service_description}
              </p>
            )}
            {subServiceList.length > 0 && (
              <>
                <br />
                {subServiceList.find((ss) => ss.type === "Inclusive") && (
                  <>
                    <h4 className={styles.type}>Inclusives</h4>
                    {subServiceList.map(
                      (sub_service, i) =>
                        sub_service.type === "Inclusive" && (
                          <>
                            <div
                              key={sub_service.service_id}
                              className={styles.service}
                              style={
                                subServiceSelected.service_id ===
                                  sub_service.service_id
                                  ? { flexDirection: "column" }
                                  : {}
                              }
                            >
                              <Image
                                src={appendImageUrl(
                                  sub_service.service_image
                                    ? sub_service.service_image
                                    : "/files/files/Group_1112x_uioXQAd.png"
                                )}
                                NativeImgProps={{
                                  className: styles.serviceImg,
                                  onClick: () =>
                                    setSubServiceSelected(sub_service),
                                  style:
                                    subServiceSelected.service_id ===
                                      sub_service.service_id
                                      ? {
                                        width: "70%",
                                        height: "auto",
                                        margin: "0 0 15px",
                                      }
                                      : { cursor: "pointer" },
                                }}
                                fallback={
                                  <Shimmer
                                    height={isMobiledevice() ? 70 : 100}
                                    width={isMobiledevice() ? 70 : 100}
                                    className={styles.serviceImg}
                                  />
                                }
                              />
                              <div style={{ flex: 10 }}>
                                <h4
                                  style={
                                    subServiceSelected.service_id ===
                                      sub_service.service_id
                                      ? { textAlign: "center" }
                                      : {}
                                  }
                                  className={styles.serviceType}
                                >
                                  {sub_service.service_name}
                                </h4>
                                <p>{sub_service.service_description}</p>
                              </div>
                            </div>
                          </>
                        )
                    )}
                  </>
                )}
                {subServiceList.find((ss) => ss.type === "Exclusive") && (
                  <>
                    <br style={{ marginBottom: 20 }} />
                    <h4 className={styles.type}>Exclusives</h4>
                    {subServiceList.map(
                      (sub_service, i) =>
                        sub_service.type === "Exclusive" && (
                          <>
                            <div
                              key={sub_service.service_id}
                              className={styles.service}
                              style={
                                subServiceSelected.service_id ===
                                  sub_service.service_id
                                  ? { flexDirection: "column" }
                                  : {}
                              }
                            >
                              <Image
                                src={appendImageUrl(
                                  sub_service.service_image
                                    ? sub_service.service_image
                                    : "/files/files/Group_1112x_uioXQAd.png"
                                )}
                                NativeImgProps={{
                                  className: styles.serviceImg,
                                  onClick: () =>
                                    setSubServiceSelected(sub_service),
                                  style:
                                    subServiceSelected.service_id ===
                                      sub_service.service_id
                                      ? {
                                        width: "70%",
                                        height: "auto",
                                        margin: "0 0 15px",
                                      }
                                      : { cursor: "pointer" },
                                }}
                                fallback={
                                  <Shimmer
                                    height={isMobiledevice() ? 70 : 100}
                                    width={isMobiledevice() ? 70 : 100}
                                    className={styles.serviceImg}
                                  />
                                }
                              />
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  width: "100%",
                                }}
                              >
                                <div>
                                  <h4 className={styles.serviceType}>
                                    {sub_service.service_name}
                                  </h4>
                                  <p>{sub_service.service_description}</p>
                                  <p className={styles.ssDuration}>
                                    Duration : {sub_service.duration} | Crew :{" "}
                                    {sub_service.crew}
                                  </p>
                                </div>
                                <div className={styles.exclusivePriceBtn}>
                                  <h4 className={styles.exclusivePrice}>
                                    ₹{sub_service.service_price?.price}
                                  </h4>
                                  {exclusivesSelectedList.some(
                                    (ss) =>
                                      ss.service_id === sub_service.service_id
                                  ) ? (
                                    exclusivesSelectedList
                                      .filter(
                                        (ss) =>
                                          ss.service_id ===
                                          sub_service.service_id
                                      )
                                      .map((ss) => (
                                        <div key={ss.service_id}
                                          style={{
                                            marginTop: 15,
                                            width: "max-content",
                                          }}
                                        >
                                          <span
                                            className={styles.minus}
                                            onClick={() =>
                                              exclusiveSubServiceQtyHandler(
                                                ss,
                                                false
                                              )
                                            }
                                          >
                                            -
                                          </span>
                                          <input
                                            className={styles.input_number}
                                            type="text"
                                            value={
                                              ss.quantity ? ss.quantity : 1
                                            }
                                            disabled
                                          />
                                          <span
                                            className={styles.plus}
                                            onClick={() =>
                                              exclusiveSubServiceQtyHandler(ss)
                                            }
                                          >
                                            +
                                          </span>
                                        </div>
                                      ))
                                  ) : (
                                    // ))
                                    <div
                                      onClick={() =>
                                        exclusiveSubServiceQtyHandler(
                                          sub_service
                                        )
                                      }
                                      className={styles.exclusiveBtn}
                                    >
                                      Add
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        )
                    )}
                  </>
                )}
              </>
            )}
          </div>
        </div>
        <div className={styles.cart}>
          <div className={styles.cartCard}>
            <div className={styles.dropdown}>
              {/* <h3 className={styles.select}>{variantSelected.sub_category}</h3> */}
              <Dropdown
                options={mainVariant.map((v) => ({
                  label: v.variant_name,
                  value: v.variant_id,
                }))}
                selectedOption={{ value: variantSelected.variant_id }}
                onChange={mainvariantDropdownHandler}
              />
              <Dropdown
                options={variantList.map((v) => ({
                  label: v.variant_name,
                  value: v.variant_id,
                }))}
                selectedOption={{ value: variantSelected.variant_id }}
                onChange={variantDropdownHandler}
              />
              <Dropdown
                options={subVariantList.map((sv) => ({
                  label: sv.sub_variant_name,
                  value: sv.sub_variant_id,
                }))}
                selectedOption={{ value: subVariantSelected.sub_variant_id }}
                onChange={subVariantDropdownHandler}
              />
              {serviceSelected.service_price?.is_per_sq_feet && (
                <OutlinedInput
                  className={styles.sqFtInput}
                  // classes={{ focused: styles.sqFtInput }}
                  placeholder="Enter sq. ft."
                  renderSuffix={() => <>sq.ft.</>}
                  inputMode="decimal"
                  type="number"
                  defaultValue={2000}
                  onChange={(e) =>
                    setSqftTotalPrice(
                      parseFloat(e.target.value) *
                      serviceSelected.service_price?.price
                    )
                  }
                />
              )}
            </div>
            {/* <div className={styles.amountContainer}>
              <span className={styles.off}>Save 50%</span>
              <span className={styles.mrp}>₹2000</span>
            </div> */}
            <div className={styles.amountContainer}>
              <h4 className={styles.typeName}>
                {serviceSelected.service_name}
              </h4>
              <span className={styles.price}>
                ₹
                {sqftTotalPrice
                  ? sqftTotalPrice.toFixed(2)
                  : serviceSelected.service_price?.price}
              </span>
            </div>
            {exclusivesSelectedList.map((exclusiveSubService) => (
              <div
                key={exclusiveSubService.service_name}
                className={styles.amountContainer}
              >
                <h4 className={styles.exclusive}>
                  {exclusiveSubService.quantity > 1
                    ? exclusiveSubService.service_name +
                    " (" +
                    exclusiveSubService.quantity +
                    ")"
                    : exclusiveSubService.service_name}
                </h4>
                <span className={styles.extra}>
                  ₹
                  {exclusiveSubService.quantity
                    ? exclusiveSubService.service_price?.price
                      ? exclusiveSubService.quantity *
                      exclusiveSubService.service_price?.price
                      : exclusiveSubService.quantity *
                      exclusiveSubService.service_price
                    : exclusiveSubService.service_price?.price ||
                    exclusiveSubService.service_price}
                </span>
              </div>
            ))}
            <div style={{ marginTop: 28 }} className={styles.amountContainer}>
              <h3 className={styles.total}>Total</h3>
              <span className={styles.price}>
                ₹
                {totalPrice
                  ? sqftTotalPrice
                    ? (sqftTotalPrice + totalPrice).toFixed(2)
                    : totalPrice + serviceSelected.service_price?.price
                  : sqftTotalPrice
                    ? sqftTotalPrice.toFixed(2)
                    : serviceSelected.service_price?.price}
              </span>
            </div>
            {alreadyInCart.price_id && updatedExclusiveList.length ? (
              <div className={styles.addToCart} onClick={updateCartHandler}>
                <h4 style={{ margin: 0 }}>Update Cart</h4>
              </div>
            ) : loading || alreadyInCart.price_id ? (
              <div
                style={{ backgroundColor: "#22ad73", cursor: "not-allowed" }}
                className={styles.addToCart}
              >
                <h4 style={{ margin: 0 }}>Added to Cart</h4>
              </div>
            ) : (
              <div className={styles.addToCart} onClick={addToCartHandler}>
                <h4 style={{ margin: 0 }}>Add To Cart</h4>
              </div>
            )}
            {/* <div className={styles.amountType}>
              <h6 className={styles.cartName}>Basic Home Cleaning</h6>
              <h6 className={styles.cartName}>Lorem Ipsum</h6>
            </div>
            <div className={styles.amountText}>
              <h6 className={styles.price}>₹1000</h6>
            </div> */}
          </div>
        </div>
      </div>

      <div ref={heroesRef}>
        {heros && heros.length > 0 && (
          <div style={{ margin: "20px 3.5%" }}>
            <h3 className={styles.sectionTitle}>Our Heroes</h3>
            <div style={{ padding: "0px 10px 40px" }}>
              <Carousels sqd={heros} />
            </div>
          </div>
        )}
      </div>

      <div ref={reviewsRef}>
        {reviews.length > 0 && (
          <div style={{ margin: "20px 3.5%" }}>
            <h3 className={styles.sectionTitle}>Reviews & Ratings</h3>
            <ReviewRating reviews={reviews} />
          </div>
        )}
      </div>
    </>
  );
}

export default Cart;
